import { BaseClient } from "../../clients/base/BaseClient";
import { SAMPLES_ENDPOINTS } from "./samples.consts";
import type { SampleResultsResponse } from "./samples.types";

/**
 * Samples API Client
 * Handles all sample-related API operations.
 */
export class SamplesClient extends BaseClient {
  /**
   * Fetch pending results for a sample by barcode/ID.
   * Results are filtered to exclude control samples and validated/rejected results.
   * @param {string} sampleId - Sample barcode/ID (case-insensitive).
   * @param {AbortSignal | null} signal - Optional abort signal for request cancellation.
   * @returns {Promise<SampleResultsResponse>} Array of pending sample results.
   */
  async fetchSampleResults(
    sampleId: string,
    signal?: AbortSignal | null,
  ): Promise<SampleResultsResponse> {
    return this.get<SampleResultsResponse>(SAMPLES_ENDPOINTS.SAMPLE_RESULTS(sampleId), {
      signal,
    });
  }
}
